
    <footer class="main-footer">

        <div class="container-fluid page-container">

            <div class="footer-main">

                <!-- BRAND -->
                <div class="footer-brand-column">

                    <a routerLink="/" class="footer-brand">
                        <img class="footer-logo" src="/logo/logo0.png" alt="ANAMETA" />
                    </a>

                    <p>
                        Daha iyi bir gelecek için insan, doğa ve
                        teknolojinin gücünü birleştiriyoruz.
                    </p>

                    <div class="social-links">

                        <a href="#" aria-label="LinkedIn">
                            <svg viewBox="0 0 24 24">
                                <path d="M6 9V19"></path>
                                <path d="M6 5V5.2"></path>
                                <path d="M10 19V13C10 10.8 11.4 9 14 9C16.8 9 18 10.8 18 14V19"></path>
                            </svg>
                        </a>

                        <a href="#" aria-label="X">
                            <svg viewBox="0 0 24 24">
                                <path d="M5 4L19 20"></path>
                                <path d="M19 4L5 20"></path>
                            </svg>
                        </a>

                        <a href="#" aria-label="YouTube">
                            <svg viewBox="0 0 24 24">
                                <path d="M4 8C4 6.5 5 5.5 6.5 5.5H17.5C19 5.5 20 6.5 20 8V16C20 17.5 19 18.5 17.5 18.5H6.5C5 18.5 4 17.5 4 16V8Z"></path>
                                <path d="M10 9L15 12L10 15V9Z"></path>
                            </svg>
                        </a>

                        <a href="#" aria-label="Instagram">
                            <svg viewBox="0 0 24 24">
                                <rect x="4" y="4" width="16" height="16" rx="5"></rect>
                                <circle cx="12" cy="12" r="4"></circle>
                                <circle cx="17.5" cy="6.5" r="1"></circle>
                            </svg>
                        </a>

                    </div>

                </div>


                <!-- ÜRÜNLER -->
                <div class="footer-links-column">

                    <h4>Ürünler</h4>

                    <a routerLink="/applications">Uygulamalar</a>
                    <a routerLink="/saas">SaaS Hizmetleri</a>
                    <a routerLink="/games">Oyunlar</a>
                    <a routerLink="/api-services">API Hizmetleri</a>

                </div>


                <!-- ÇÖZÜMLER -->
                <div class="footer-links-column">

                    <h4>Çözümler</h4>

                    <a routerLink="/solutions/sectors">Sektörlere Göre</a>
                    <a routerLink="/solutions/technologies">Yeni Nesil Teknolojiler</a>
                    <a routerLink="/consulting">Danışmanlık</a>
                    <a routerLink="/solutions/custom">Özel Çözümler</a>

                </div>


                <!-- KAYNAKLAR -->
                <div class="footer-links-column">

                    <h4>Kaynaklar</h4>

                    <a routerLink="/documents">Dökümanlar</a>
                    <a routerLink="/trainings">Eğitimler</a>
                    <a routerLink="/blog">Blog</a>
                    <a routerLink="/events">Etkinlikler</a>

                </div>


                <!-- KURUMSAL -->
                <div class="footer-links-column">

                    <h4>Kurumsal</h4>

                    <a routerLink="/about">Hakkımızda</a>
                    <a routerLink="/career">Kariyer</a>
                    <a routerLink="/sustainability">Sürdürülebilirlik</a>
                    <a routerLink="/contact">İletişim</a>

                </div>


                <!-- NEWSLETTER -->
                <div class="footer-newsletter">

                    <h4>Gelişmelerden haberdar olun.</h4>

                    <div class="newsletter-input">

                      <input
    type="email"
    [value]="newsletterEmail"
    (input)="OnNewsletterEmailInput($event)"
    placeholder="E-posta adresiniz"
    aria-label="E-posta adresiniz"
/>

                        <button type="button" (click)="subscribeNewsletter()" aria-label="Gönder">
                            <svg viewBox="0 0 24 24">
                                <path d="M5 12H19"></path>
                                <path d="M14 7L19 12L14 17"></path>
                            </svg>
                        </button>

                    </div>

                </div>

            </div>


            <!-- FOOTER BOTTOM -->
            <div class="footer-bottom">

                <div class="footer-copyright">
                    © 2026 ANAMETA. Tüm hakları saklıdır.
                </div>

                <div class="footer-legal">

                    <a routerLink="/privacy">Gizlilik Politikası</a>

                    <span></span>

                    <a routerLink="/terms">Kullanım Koşulları</a>

                    <span></span>

                    <a routerLink="/cookies">Çerez Tercihleri</a>

                </div>

                <div class="footer-language">

                    <svg viewBox="0 0 24 24">
                        <circle cx="12" cy="12" r="9"></circle>
                        <path d="M3 12H21"></path>
                        <path d="M12 3C14.4 5.5 15.7 8.5 15.7 12C15.7 15.5 14.4 18.5 12 21"></path>
                        <path d="M12 3C9.6 5.5 8.3 8.5 8.3 12C8.3 15.5 9.6 18.5 12 21"></path>
                    </svg>

                    <span>TR</span>

                    <svg class="small-chevron" viewBox="0 0 24 24">
                        <path d="M7 9L12 14L17 9"></path>
                    </svg>

                </div>

                <button type="button" class="back-to-top" (click)="scrollToTop()" aria-label="Yukarı çık">
                    <svg viewBox="0 0 24 24">
                        <path d="M12 19V5"></path>
                        <path d="M7 10L12 5L17 10"></path>
                    </svg>
                </button>

            </div>

        </div>

    </footer>

